<template>
<template v-if="init">
    <template v-if="showTabs">
        <h4 class="text-left my-2 text-xl text-gray-600 dark:text-white/75 font-semibold">
            {{ stats.localization['trade_statistics_available_bots_title'].slice(0, -2) }}
        </h4>
        
        <n-tabs
            type="line"
            size="large"
            :value="currentTab"
            @update:value="changeTab">
            <n-tab-pane
                v-for="(tab, i) in tabs"
                :key="i"
                :name="tab.name"
                :disabled="loading">
                <template #tab>
                    <div class="flex items-center">
                        {{ tab.title }}
                        <n-tag size="small" v-if="tab.name === 'transactions'" round type="warning" :bordered="false" class="ml-2 text-[10px]">
                            <strong>NEW</strong>
                        </n-tag>
                    </div>
                </template>
            <router-view></router-view>
            </n-tab-pane>
        </n-tabs>
    </template>
    <router-view v-else></router-view>
</template>
</template>
    
<script>
// general
import general from './general';

// store
import { useStats } from '@store/stats';
import { useGl } from '@store/ts/gl';
    
// i18n
import { useI18n } from 'vue-i18n';

// UI
import {
    NTag,
    NCard,
    NTabs,
    NTabPane } from 'naive-ui';
    
export default {
    name: 'trade-statistic-desktop',
    components: {
        NTag,
        NCard,
        NTabs,
        NTabPane,
    },
    setup(props, context) {
        // store
        const gl = useGl();
        const stats = useStats();

        // i18n
        const { t } = useI18n();
    
        return {
            gl,
            stats,
            ...general(props, context),
        };
    },
};
</script>